module.exports = __webpack_public_path__ + "static/Group_6256_2x-6baf34a17ad132346c517c1c81a797e3.png";